export default `
  query listOrgProjects($orgId: String!) {
    listOrgProjects(orgId: $orgId) {
      id
      name
      organisationId
      workflows {
        items {
          id
          name
        }
        nextToken
      }
    }
  }
`
